//import packages from node modules
import React, { useEffect, useState, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'
import { change } from 'redux-form'

//import utilities functions
import { addCssClass, removeCssClass } from '../../../../utilities/function/common'

//import shared components
import Tooltip from '../../tooltip'

let Dropdown = props => {
  const { input, list, meta, initialValue, label, className, description, placeholder } = props
  const { dispatch, form, error,touched } = meta
  const { name, value } = input
  const [isOpen, setIsOpen] = useState(false)
  const [isFocus, setIsFocus] = useState(false)
  const [selectedDropdown,setSelectedDropdown] = useState(null)
  const getSelected = () => {
    if (value && list && list.length > 0) {
      return list.find((item) => item.value === value)
    }
  }

  const selected = getSelected()
  const dropdownEl = useRef(null)
  const clickaway = (e) => {
    if (dropdownEl && dropdownEl.current !== e.target && !dropdownEl.current.contains(e.target)) {
      setIsOpen(false)
    }
  }
  const isError = () => {
    return (error && touched)
  }
  const getErrorMessage = () => {
    return error
  }

  const openCallback = useCallback(()=>{
    document.addEventListener('touchstart', clickaway)
    document.addEventListener('click', clickaway)
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        setIsOpen(false)
      }
    })
  },[])
  const closeCallback = useCallback(()=>{
    document.removeEventListener('click', clickaway)
    document.removeEventListener('touchstart', clickaway)
  },[])
  const focusCallback = useCallback(()=>{
    setIsOpen(true)
    setSelectedDropdown(null)
    setIsFocus(true)
  },[])
  const blurCallback = useCallback(()=>{
    setIsOpen(false)
    setIsFocus(false)
  },[])

  const initFlag = useRef(false)
  const initCallback = useCallback(()=>{
    if (initialValue && !initFlag.current) {
      dispatch(change(form, name, initialValue))
      initFlag.current = true
    }
  },[dispatch, initialValue, form, name])
  const keyUpCallback = (e) => {
    const getLastIndex = () => {
      return list && list.length ? list.length -1 : 0
    }
    const goUp = () => {
      if(isOpen) {
        if (typeof selectedDropdown !== "number") {
          setSelectedDropdown(0)
        } else {
          let selected = selectedDropdown - 1
          if (selected < 0) {
            selected = getLastIndex()
          }
          setSelectedDropdown(selected)
        }
      }else{
        setIsOpen(true)
      }
    }
    const goDown =  () => {
      if(isOpen){
        if(typeof selectedDropdown !== "number"){
          setSelectedDropdown(0)
        }else{
          let selected = selectedDropdown + 1
          if(selected > getLastIndex()){
            selected = 0
          }
          setSelectedDropdown(selected)
        }
      }else{
        setIsOpen(true)
      }
    }
    const select = () => {
      dispatch(change(form, name, list[selectedDropdown].value))
      setIsOpen(false)
    }
    switch (e.key) {
      case "Up": // IE/Edge specific value
      case "ArrowUp":
        goUp()
        break;
      case "Down": // IE/Edge specific value
      case "ArrowDown":
        goDown()
        break;
      case "Enter":
      case " ":
      case "Spacebar":
        select()
        break;
      default:
        e.preventDefault()
        break;
    }
  }


  useEffect(() => {
    initCallback()
    if (isOpen) {
      openCallback()
    } else {
      closeCallback()
    }
    return (() => {
      closeCallback()
    })
  }, [isOpen, openCallback, closeCallback,initCallback])

  const renderList = () => {
    const addSelectedDropdownCss = (index) =>{
      if(index === selectedDropdown){
        return ' shades-primary-background-2-100'
      }
      return ''
    }
    if (list && list.length && isOpen) {
      const renderItem = () => {
        return list.map((item, index) => {
          const { label, value } = item
          return (
            <li
              key={index}
              className={`lines-border-1-100 text-font-1-100${addSelectedDropdownCss(index)}`}
              onClick={e => {
                e.preventDefault()
                dispatch(change(form, name, value))
                setIsOpen(false)
              }}
              onMouseLeave={e => {
                removeCssClass(e.currentTarget, 'shades-primary-background-2-100')
              }}  
              onMouseEnter={e => {
                addCssClass(e.currentTarget, 'shades-primary-background-2-100')
              }}
            >{label}</li>
          )
        })
      }
      return (
        <div className={'of-dropdown__list'}>
          {renderItem()}
        </div>
      )
    }
    return (<></>)
  }
  const renderLabel = () => {
    if (label) {
      return <span className={'of-dropdown__label text-font-1-100'}>{label}</span>
    }
    return (<></>)
  }
  const renderDescription = () => {
    if (description) {
      return (
        <div className={'of-dropdown__description'}>
          <Tooltip className={'of-dropdown__tooltip'} description={description}/>
        </div>
      )

    }
    return (<></>)
  }
  const renderSelectedBox = () => {
    if(!initialValue && !selected){
      const text  = placeholder? placeholder :
          label? label : ''
      return (<span className={'of-dropdown__placeholder text-font-4-100'}>{text}</span>)
    }
    if(selected){
      return selected.label
    }
    return ''
  }

  if (list && list.length === 1) {
    return (
      <div className={'of-dropdown-single'}>
        <div className={'of-dropdown-single__text'}>{list && list.length > 0 ? list[0].label : ''}</div>
        <input {...input} type={'hidden'}/>
      </div>
    )
  }

  return (
    <div className={`of-dropdown${className ? ' ' + className : ''}`}
         ref={dropdownEl}
         tabIndex={0}
         onFocus={focusCallback}
         onBlur={blurCallback}
         onKeyUp={keyUpCallback}
    >
      {renderLabel()}
      {renderDescription()}
      <div className={`of-dropdown__top ${isError() ? 'status-border-2-100' : 
          (isOpen && selected) || isFocus ? 'primary-border-1-100' : 'lines-border-1-100'
      }`} onClick={()=>{
        setIsOpen(true)
      }}>
        <div className={'of-dropdown__selected text-font-1-100'}>
          <div className={'of-dropdown__selected-text'}>{renderSelectedBox()}</div>
          <div className={'of-dropdown__arrow'}>
            <i className={`of-dropdown__arrow-icon icon-of-arrow${isOpen && selected ? ' primary-font-1-100' : ''}`}/>
          </div>
        </div>
      </div>
      <div className={'of-dropdown__bottom'}>
        {renderList()}
      </div>
      <input {...input} type={'hidden'}/>
      {isError() ? <div className={'of-textfield__error status-font-2-100'}>{getErrorMessage()}</div> : <></>}
    </div>
  )
}

Dropdown.propTypes = {
  input: PropTypes.any,
  name: PropTypes.string,
  list: PropTypes.array,
  meta: PropTypes.any,
  initialValue: PropTypes.any,
  label: PropTypes.string,
  className: PropTypes.string,
  description: PropTypes.string,
  placeholder: PropTypes.string
}

export default Dropdown